import { render, staticRenderFns } from "./LongevityLevel.vue?vue&type=template&id=6ea3f018"
import script from "./LongevityLevel.vue?vue&type=script&lang=js"
export * from "./LongevityLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports